import { cva } from '@/styled-system/css';

export const dateTimeBlockDatesOuterRecipe = cva({
  base: {
    '& .c11n_icon-button': {
      flexShrink: 0,
    },
  },
  variants: {
    includeOffset: {
      true: {
        alignItems: 'center',
        display: 'flex',
        gap: 'tighter',
      },
    },
  },
});

export const dateTimeBlockDatesInnerRecipe = cva({
  base: {
    alignItems: 'center',
    display: 'grid',
    flexGrow: 1,
    gap: 'tighter',
  },
  variants: {
    isTouchScreen: {
      true: {
        'display': 'flex',
        'overflowX': 'auto',
        'scrollSnapType': 'x mandatory',
        'scrollbarWidth': 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
          inlineSize: 0,
        },
        '& .c11n_date-time-block__day': {
          scrollSnapAlign: 'start',
        },
        '&::before, &::after': {
          content: '""',
          display: 'block',
          flexShrink: 0,
        },
      },
      false: {
        display: 'grid',
      },
    },
    datesToShow: {
      2: {},
      3: {},
      4: {},
      5: {},
    },
    touchScreenOffset: {
      tightest: {},
      tighter: {},
      tight: {},
      default: {},
      loose: {},
      looser: {},
    },
  },
  compoundVariants: [
    {
      isTouchScreen: false,
      datesToShow: 2,
      css: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    },
    {
      isTouchScreen: false,
      datesToShow: 3,
      css: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
    },
    {
      isTouchScreen: false,
      datesToShow: 4,
      css: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
    },
    {
      isTouchScreen: false,
      datesToShow: 5,
      css: {
        gridTemplateColumns: 'repeat(5, 1fr)',
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'tightest',
      css: {
        'marginInline': `calc({spacing.tightest} * -1)`,
        'scrollPaddingInlineStart': '{spacing.tightest}',
        '&::before': {
          inlineSize: '{spacing.tightest}',
        },
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'tighter',
      css: {
        'marginInline': `calc({spacing.tighter} * -1)`,
        'scrollPaddingInlineStart': '{spacing.tighter}',
        '&::before': {
          inlineSize: '{spacing.tighter}',
        },
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'tight',
      css: {
        'marginInline': `calc({spacing.tight} * -1)`,
        'scrollPaddingInlineStart': '{spacing.tight}',
        'paddingInlineEnd': `calc({spacing.tight} - {spacing.tighter})`,
        '&::before': {
          inlineSize: '{spacing.tight}',
        },
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'default',
      css: {
        'marginInline': `calc({spacing.default} * -1)`,
        'scrollPaddingInlineStart': '{spacing.default}',
        'paddingInlineEnd': `calc({spacing.default} - {spacing.tighter})`,
        '&::before': {
          inlineSize: '{spacing.default}',
        },
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'loose',
      css: {
        'marginInline': `calc({spacing.loose} * -1)`,
        'scrollPaddingInlineStart': '{spacing.loose}',
        'paddingInlineEnd': `calc({spacing.loose} - {spacing.tighter})`,
        '&::before': {
          inlineSize: '{spacing.loose}',
        },
      },
    },
    {
      isTouchScreen: true,
      touchScreenOffset: 'looser',
      css: {
        'marginInline': `calc({spacing.looser} * -1)`,
        'scrollPaddingInlineStart': '{spacing.looser}',
        'paddingInlineEnd': `calc({spacing.looser} - {spacing.tighter})`,
        '&::before': {
          inlineSize: '{spacing.looser}',
        },
      },
    },
  ],
});
